import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Button, Tooltip, Spin } from "antd";
import { defaultFormLayout } from "../../common/Utils";
import { familyStore } from "../../store/family/FamilyStore";
import { observer } from "mobx-react";
import { FormOutlined } from "@ant-design/icons";

export const FamilyEditChild = observer(({ child }) => {
  const { updateChild } = familyStore;
  const [form] = Form.useForm();
  const [showDlg, setShowDlg] = useState(false);

  useEffect(() => {
    form.setFieldsValue(updateChild.child);
  }, [updateChild.child]);

  const save = () => {
    form.validateFields().then((values) => {
      updateChild.save(values).then(() => setShowDlg(false));
    });
  };

  const onEdit = (childId) => {
    setShowDlg(true);
    updateChild.show(childId);
  };

  return (
    <Tooltip title="Edit">
      <Button onClick={() => onEdit(child.childId)} size="small" type="link" shape="circle" icon={<FormOutlined />} />
      <Modal
        title={`Edit Child`}
        visible={showDlg}
        centered
        onOk={save}
        confirmLoading={updateChild.saving}
        onCancel={() => setShowDlg(false)}
        maskClosable={false}
      >
        <Form form={form} {...defaultFormLayout}>
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: "Please input first name" }]}
          >
            <Input maxLength={50} placeholder="Enter first name" />
          </Form.Item>
          <Form.Item label="School" name="schoolId" rules={[{ required: true, message: "Please select school name" }]}>
            <Select
              placeholder="Enter school name to search"
              showSearch
              filterOption={false}
              notFoundContent={
                updateChild.loadingSchool ? (
                  <Spin size="small" />
                ) : updateChild.keyword.trim() ? (
                  "No data."
                ) : (
                  "Enter school name to search."
                )
              }
              onSearch={(val) => updateChild.setKeyword(val)}
              onChange={(val) => {
                updateChild.onSchool(val);
                form.setFieldsValue({ grade: null });
              }}
            >
              {updateChild.orgs.map((s: any) => (
                <Select.Option key={s.id} value={s.id}>
                  {s.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Grade" shouldUpdate required>
            {() => {
              return (
                <Form.Item name="grade" noStyle rules={[{ required: true, message: "Please input grade" }]}>
                  <Select style={{ width: "100%" }} placeholder="Please select">
                    {updateChild.grades.map((p) => (
                      <Select.Option key={p} value={p}>
                        {p}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item label="Email" name="email" rules={[{ type: "email", message: "Erroneous email address format." }]}>
            <Input placeholder="Enter email" />
          </Form.Item>
        </Form>
      </Modal>
    </Tooltip>
  );
});
